export default {
  selectTicketType: '选择门票类型',
  confirmTicketDetails: '确认门票信息',
  payment: '支付门票订单',
  receiveETicket: '收取电子门票',
  exhibitionTickets: '展会门票',
  viewExhibitions: '查看展会',
  exhibitionDates: '展会时间',
  viewMap: '查看地图',
  organizer: '主办单位',
  venue: '举办展馆',
  hallNumber: '展馆号',
  venueAddress: '举办地址',
  ticketType: '门票类型',
  eTicket: '电子票',
  fullEventPass: '展期票',
  singleDayTicket: '单日票',
  freeAdmission: '免费',
  limitedTimeOffer: '限时',
  soldOut: '暂缺',
  discounted: '折',
  RMB: '元',

  // 价格相关
  priceTitle: '价格明细',
  ticketPrice: '门票',
  serviceFee: '服务费',
  vat: '增值税',
  promotion: '促销优惠',
  totalAmount: '总额',
  limitedTimeFree: '限时免费',
  feeInclusion: '（含：增值税，服务费）',

  // 支付相关
  modifyOrder: '返回修改订单',
  alipay: '支付宝',
  wechatPay: '微信支付',
  redirectToAlipay: '点击"去支付"，跳转到支付宝付款',
  scanWechatQR: '点击"去支付"，打开手机微信"扫一扫"，扫描二维码支付',
  proceedToPay: '去支付',
  paymentSecurity: '聚展支付安全承诺',
  wechatScanPayment: '打开手机微信"扫一扫"，扫描二维码支付',

  // 表单相关
  selectCompanyIndividual: '选择公司/个人',
  company: '公司',
  individual: '个人',
  companyName: '公司名称',
  attendeeName: '姓名',
  companyNameInput: '请输入公司名称',
  nameInput: '请输入姓名',
  confirmButton: '确 定',
  cancelButton: '取 消',

  // 访客管理
  visitor: '观展人',
  addVisitor: '新增观展人',
  addAttendee: '新增观展人信息',
  fullName: '姓名',
  gender: '性别',
  male: '男',
  female: '女',
  jobTitle: '职位',
  mobileNumber: '手机号',
  email: '邮箱',
  idType: '证件类型',
  idNumber: '证件号',
  actions: '操作',
  edit: '编辑',
  delete: '删除',

  // 证件类型
  idCard: '身份证',
  passport: '护照',
  hkMacaoPass: '港澳居民来往内地通行证',
  taiwanPass: '台湾居民来往内地通行证',

  // 购票须知
  ticketingTerms: '购票须知',
  agreeSubmit: '同意以上协议并提交订单',
  ticketGuidelines:
    '购票成功后，打开网站/小程序出示门票二维码，请携带购票时填写的证件原件验证入场，最终地址以展会现场实际为准。',
  entryInstructions:
    '门票预订成功后，请携带观展人本人身份证原件刷卡入场或至现场服务台换领纸质进馆证！',
  entryProcedure:
    '门票预订成功后，请携带观展人本人护照原件及电子门票至现场服务台或自助机换领进馆证入场！',

  // 注意事项
  notes: '注意事项',
  preRegistrationTickets: '预登记门票',
  visitorRealNameSystem: '{num}.参观人员需展会实名制',
  bookingPurpose:
    '{num}.为减少展会现场排队及人员集聚接触，预约成功后会以短信、微信或邮件的形式推送',
  ticketStatus: '无票状态',
  bookingStatus: '{num}.暂未开放在线预约门票服务',
  bookingClosed: '{num}.已截止在线预约门票服务',
  refundPolicy2: '不支持退',
  ticketNature:
    '票品为有价证券，非普通商品，其背后承载的文化服务具有时效性，稀缺性等特征，不支持退换',
  realNamePolicy: '实名制观展',
  ticketingRule: '本项目需实名制购票及入场，观展请本人携带购票时填写证件验证入场',

  // 门票类型说明
  deliveryMethod: '配送方式：电子票，支付成功后，无需取票，前往"我的门票"查看入场凭证。',
  precautions: '注意事项：门票时间均为展会当地时间，展会最后一天需在14:00前入场。'
}
